<template>
    <Layout class="i-layout">
        <Sider v-if="!isMobile && !hideSider" class="i-layout-sider" :class="siderClasses" :width="menuSideWidth">
            <i-menu-side :hide-logo="isHeaderStick && headerFix && showHeader" />
        </Sider>
        <Layout class="i-layout-inside" :class="insideClasses">
            <transition name="fade-quick">
                <Header class="i-layout-header" :class="headerClasses" :style="headerStyle" v-show="showHeader" v-resize="handleHeaderWidthChange">
                    
<!--                     <i-sidebar  @on-search="searchMenu" :extend-search="true" :extend-nav="true" :extend="false" :extend-search-placeholder="$t('page.nav.inputMenuName')" :menu-list="menuList" extend extend-icon="ios-apps" :extend-title="$t('page.nav.menuAndFuncation')"  :extend-menu-list="extendMenuList" v-if="mutiFuncationMenu" />
 -->                    <!--extend-search="false" @on-search="searchMenu" -->
                    <div class="i-layout-sider-logo bbn" v-if="mutiFuncationMenu" >
                        <transition name="fade-quick">
                            <i-link to="/">
                                <img src="@/assets/images/logo-small.png" v-if="menuCollapse">
                                <img src="@/assets/images/logo.png" v-else-if="siderTheme === 'light'">
                                <img src="@/assets/images/logo-dark.png" v-else>
                            </i-link>
                        </transition>
                    </div>
                    <span :class="{'v-h':mutiFuncationMenu}">
                        <i-header-logo v-if="isMobile && showMobileLogo" />
                        <i-header-logo v-if="!isMobile && isHeaderStick && headerFix" />

                        <i-header-collapse v-if="(isMobile || showSiderCollapse) && !hideSider" @on-toggle-drawer="handleToggleDrawer" />
                        <i-header-reload v-if="!isMobile && showReload" @on-reload="handleReload" />
                    </span>

                    <span style="flex: 1;" :class="{'v-h':mutiFuncationMenu}">
                        <i-menu-head v-if="headerMenu && !isMobile" ref="menuHead" />
                        <!-- <i-header-breadcrumb v-if="showBreadcrumb && !headerMenu && !isMobile" ref="breadcrumb" /> -->
                        <!-- <i-header-search v-if="showSearch && !headerMenu && !isMobile && !showBreadcrumb" /> -->
                    </span>
                    <span v-if="!isMobile" style="display:inline-block" class="headersearch">
                        <Input  :search="true" suffix="ios-search"  v-model="searchValue" @on-search="onSearch" 
                            :placeholder="$t('sclm.sclmTApplyContract.fullSearching')" 
                            v-if="$store.state.admin.user.info.buttonPermision['contractSearch']"
                        />
                    </span>
                    <span v-else style="display:contents" class="mobileHeadersearch">
                        <Input  style="width: 20px" :search="true" suffix="ios-search"  v-model="searchValue" @on-search="onSearch"  />
                    </span>


                    <div class="i-layout-header-right" style="display: flex;position: fixed; top: 0px;right: 0px;">
                        <i-header-search v-if="(showSearch && isMobile) || (showSearch && (headerMenu || showBreadcrumb))" />
                        <!-- 演示门户下拉 -->
                        <Dropdown v-if="false" @on-click="homenamechange" :style="isMobile ? {} :{marginRight:'10px'}">
                            <span class="headertext" style="cursor: pointer;">
                                {{ homename }}
                                <Icon type="ios-arrow-down"></Icon>
                            </span>
                            <DropdownMenu slot="list" >
                                <DropdownItem v-for="(val,index) in homepageList" :key="index" :name="val.value">{{ val.name }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

            			<i-link :to="apiBaseURL" target="_blank" v-if="userInfoLoaded" v-ab-btn-rights:develop_platform > {{ $t('menu.develop_platform') }} </i-link>
						<span v-if="!isMobile" class="i-layout-header-trigger i-layout-header-trigger-min" @click="changeDarkCss()">
                            <Icon type="md-sunny" size="20" class="pointer " v-if="headerMenu && isDark" />
                            <Icon type="ios-moon" size="20" class="pointer " v-if="headerMenu && !isDark" />
                        </span>
						
                        <i-menu-head v-if="headerMenu && isMobile" />
                        <i-header-log v-if="isDesktop && showLog" />
                        <!-- <i-header-fullscreen v-if="isDesktop && showFullscreen" /> -->
            			<i-header-notice class="headertext" v-if="showNotice" :title="newNumber" @increase="haveChange"/>
                        <i-header-user class="headertext"/>
                        <i-header-i18n calss="headertext" v-if="showI18n" />
                        <i-header-setting v-if="enableSetting && !isMobile" />
                    </div>
                </Header>
            </transition>
            <Content class="i-layout-content" :class="contentClasses">
                <transition name="fade-quick">
                    <i-tabs v-if="tabs" v-show="showHeader" @on-reload="handleReload" :class="{'l0 w100':mutiFuncationMenu}"/>
                </transition>
                <div class="i-layout-content-main">
                    <keep-alive :include="keepAlive">
                        <router-view v-if="loadRouter" />
                    </keep-alive>
                </div>
            </Content>
            <i-copyright />
        </Layout>
        <div v-if="isMobile && !hideSider">
            <Drawer v-model="showDrawer" placement="left" :closable="false" :class-name="drawerClasses">
                <i-menu-side />
            </Drawer>
        </div>
    </Layout>
</template>
<script>
    import iMenuHead from './menu-head';
    import iMenuSide from './menu-side';
    import iHeaderLogo from './header-logo';
    import iHeaderCollapse from './header-collapse';
    import iHeaderReload from './header-reload';
    import iHeaderBreadcrumb from './header-breadcrumb';
    import iHeaderSearch from './header-search';
    import iHeaderLog from './header-log';
    import iHeaderFullscreen from './header-fullscreen';
    import iHeaderNotice from './header-notice';
    import iHeaderUser from './header-user';
    import iHeaderI18n from './header-i18n';
    import iHeaderSetting from './header-setting';
    import iTabs from './tabs';
    import iCopyright from '@/components/copyright';

    import { mapState, mapGetters, mapMutations } from 'vuex';
    import Setting from '@/setting';

    import { requestAnimation } from '@/libs/util';
    import { getHeaderName, getMenuSider, getSiderSubmenu,getSiderOpenNames} from '@/libs/ab-system';

    export default {
        name: 'BasicLayout',
        components: { iMenuHead, iMenuSide, iCopyright, iHeaderLogo, iHeaderCollapse, iHeaderReload, iHeaderBreadcrumb, iHeaderSearch, iHeaderUser, iHeaderI18n, iHeaderLog, iHeaderFullscreen, iHeaderSetting, iHeaderNotice, iTabs},
        data () {
            return {
                searchValue:'',//搜索
                
                homename:$t('sclm.homepage.ordinaryPortal'),//当前显示的门户名称
                homepageList:[//门户下拉列表
                    /* {
                        value:1,
                        name:'总经理门户'
                    },
                    {
                        value:2,
                        name:'财务门户'
                    },
                    {
                        value:3,
                        name:'法务门户'
                    },
                    {
                        value:4,
                        name:'采购门户'
                    },
                    {
                        value:5,
                        name:'销售门户'
                    },
                    {
                        value:6,
                        name:'菲婷丝法务门户'
                    }, */
                    {
                        value:7,
                        name:$t('sclm.homepage.ordinaryPortal')
                    },
                ],
                showDrawer: false,
                ticking: false,
                isDark: false,
                headerVisible: true,
                oldScrollTop: 0,
                isDelayHideSider: false, // hack，当从隐藏侧边栏的 header 切换到正常 header 时，防止 Logo 抖动
                loadRouter: true,
                apiBaseURL: Setting.apiBaseURL,
                imgBaseUrl:Setting.apiBaseURL+"sys/sysFile/download?fileId=",
                number: 0,
                newNumber: 0,
                userInfoLoaded : false,
                userMenuList:[],
                menuList: [
                    // {
                    //     title: '工作台',
                    //     custom: 'i-icon-demo i-icon-demo-dashboard',
                    //     path: '/dashboard/console'
                    // },
                    // {
                    //     title: '待办事项',
                    //     custom: 'i-icon-demo i-icon-demo-form',
                    //     path: '/bpm/my/todoTaskList'
                    // },
                    // {
                    //     title: '办理历史',
                    //     custom: 'i-icon-demo i-icon-demo-list',
                    //     path: '/bpm/my/approveHistoryList'
                    // },
                    // {
                    //     title: '消息列表',
                    //     custom: 'i-icon-demo i-icon-demo-search',
                    //     path: '/bpm/my/xxlb'
                    // },
                    // {
                    //     title: '我的草稿',
                    //     custom: 'i-icon-demo i-icon-demo-profile',
                    //     path: '/bpm/my/draft'
                    // },
                    // {
                    //     title: '发起申请',
                    //     custom: 'i-icon-demo i-icon-demo-result',
                    //     path: '/bpm/my/myDefinitionList'
                    // },
                    // {
                    //     title: '申请历史',
                    //     custom: 'i-icon-demo i-icon-demo-exception',
                    //     path: '/bpm/my/applyHistory'
                    // },
                    // {
                    //     title: '我的抄送',
                    //     custom: 'i-icon-demo i-icon-demo-setting',
                    //     path: '/bpm/my/carboncopyReceiveList'
                    // },
                    // {
                    //     title: '流程代理',
                    //     custom: 'i-icon-demo i-icon-demo-editor',
                    //     path: '/bpm/plugin/userAgencyConfigList'
                    // }
                ],
                extendMenuList: [
                    // {
                    //     title: '个人办公',
                    //     children: [
                    //         {
                    //             title: '事项办理',
                    //             // path: '/dashboard/console',
                    //             icon: 'ios-boat'
                    //         },
                    //         {
                    //             title: '待办事项',
                    //             path: '/bpm/my/todoTaskList',
                    //             custom: 'i-icon-demo i-icon-demo-tool'
                    //         },
                    //     ]
                    // },
                ]
            }
        },
        computed: {
            ...mapState('admin/layout', [
                'siderTheme',
                'headerTheme',
                'headerStick',
                'tabs',
                'tabsFix',
                'siderFix',
                'headerFix',
                'mutiFuncationMenu',
                'headerHide',
                'headerMenu',
                'isMobile',
                'isTablet',
                'isDesktop',
                'menuCollapse',
                'showMobileLogo',
                'showSearch',
                'showNotice',
                'showFullscreen',
                'showSiderCollapse',
                'showBreadcrumb',
                'showLog',
                'showI18n',
                'showReload',
                'enableSetting',
                'openMsgBoxOnNewMsg'
            ]),
            ...mapState('admin/page', [
                'keepAlive'
            ]),
            ...mapGetters('admin/menu', [
                'hideSider'
            ]),
            // 如果开启 headerMenu，且当前 header 的 hideSider 为 true，则将顶部按 headerStick 处理
            // 这时，即使没有开启 headerStick，仍然按开启处理
            isHeaderStick () {
                let state = this.headerStick;
                if (this.hideSider) state = true;
                return state;
            },
            showHeader () {
                let visible = true;
                if (this.headerFix && this.headerHide && !this.headerVisible) visible = false;
                return visible;
            },
            headerClasses () {
                return [
                    `i-layout-header-color-${this.headerTheme}`,
                    {
                        'i-layout-header-fix': this.headerFix,
                        'i-layout-header-fix-collapse': this.headerFix && this.menuCollapse,
                        'i-layout-header-mobile': this.isMobile,
                        'i-layout-header-stick': this.isHeaderStick && !this.isMobile,
                        'i-layout-header-with-menu': this.headerMenu,
                        'i-layout-header-with-hide-sider': this.hideSider || this.isDelayHideSider,
                        'w100 l0':this.mutiFuncationMenu
                    }
                ];
            },
            headerStyle () {
                const menuWidth = this.isHeaderStick ? 0 : this.menuCollapse ? 80 : Setting.menuSideWidth;
                return this.isMobile || !this.headerFix ? {} : {
                    width: `calc(100% - ${menuWidth}px)`
                };
            },
            siderClasses () {
                return {
                    'i-layout-sider-fix': this.siderFix,
                    'i-layout-sider-dark': this.siderTheme === 'dark',
                    'hide': this.mutiFuncationMenu,
                };
            },
            contentClasses () {
                return {
                    'i-layout-content-fix-with-header': this.headerFix,
                    'i-layout-content-with-tabs': this.tabs,
                    'i-layout-content-with-tabs-fix': this.tabs && this.tabsFix
                };
            },
            insideClasses () {
                return {
                    'i-layout-inside-fix-with-sider': this.siderFix,
                    'i-layout-inside-fix-with-sider-collapse': this.siderFix && this.menuCollapse,
                    'i-layout-inside-with-hide-sider': this.hideSider,
                    'i-layout-inside-mobile': this.isMobile,
                    'pl0': this.mutiFuncationMenu,
                };
            },
            drawerClasses () {
                let className = 'i-layout-drawer';
                if (this.siderTheme === 'dark') className += ' i-layout-drawer-dark';
                return className;
            },
            menuSideWidth () {
                return this.menuCollapse ? 80 : Setting.menuSideWidth;
            }
        },
        watch: {
            hideSider () {
                this.isDelayHideSider = true;
                setTimeout(() => {
                    this.isDelayHideSider = false;
                }, 0);
            },
            '$route' (to, from) {
                if (to.name === from.name && to.meta.title===to.meta.title) {
                    // 相同路由，不同参数，跳转时，重载页面
                    if (Setting.sameRouteForceUpdate) {
                        this.handleReload();
                    }
                }
            },
            number: function(newVal,o) {
                if(o && newVal>o){
                  // this.open()
                }
              this.newNumber = newVal;
           }
        },
        methods: {
            //搜索
            onSearch(){
                let searchValue = this.searchValue;
                this.$router.push({
                    name:'contractSearch',
                    query:{},
                    params:{
                        searchValue:searchValue
                    }
                });
                this.searchValue = "";
            },
            homenamechange(e){

                var index = this.homepageList.findIndex(val=>val.value === e)
                this.homename = this.homepageList[index].name
                this.$store.commit('admin/menu/setHomeType', e);

                let routeName = this.$route.name;
                if(routeName!='dashboard-console'){
                    this.$router.push({name:'dashboard-console'});
                }

            },
            ...mapMutations('admin/layout', [
                'updateMenuCollapse'
            ]),
           ...mapMutations('admin/page', [
                'keepAlivePush',
                'keepAliveRemove'
            ]),
            ...mapMutations('admin/layout', [
                'updateLayoutSetting'
            ]),
            //获取页面配置权限
            getPagPermission(){
                let url = "/sys/sysConfigure/getByBusKey";
                let post = this.abHttpUtil.postForm(url, {});
                this.abTools.getResultData(post, (data,result) => {
                    //this.$store.commit('admin/pageAuthConfig/setDatas', data);
                    this.$store.dispatch('admin/pageAuthConfig/set', data);
                }); 
            },
            // 搜索菜单
            searchMenu (words){
                this.initMutiFunctionMenu(words);
            },
            initMutiFunctionMenu(words){

                words = words || "";
                this.menuList = [];
                this.extendMenuList = [];

                for(var i = 0 ; i < this.userMenuList.length ; i++){
                   var menu = this.userMenuList[i];
                   var tempMenu = {
                       title: menu.name,
                       children: [],
                       icon: menu.icon,
                   };

                   this.extendMenuList.push(tempMenu);

                   var hasMatch = false;

                   for(var j = 0 ; j < menu.children.length ; j++){
                       var subMenu = menu.children[j];
                       var tempSubMenu = {
                            title: subMenu.name,
                            path: tempMenu.children.length==0?subMenu.url:"",
                            children: [],
                            icon: subMenu.icon || "ios-list-box",
                       }

                       var hasSubMatch = false;
                       var hasSubSubMatch = false;

                       if(subMenu.name.indexOf(words)>=0){
                           hasMatch = true;
                           hasSubMatch = true;
                       }

                       tempMenu.children.push(tempSubMenu);

                       for(var k = 0 ; k < subMenu.children.length ; k++){
                            var subSubMenu = subMenu.children[k];

                            if(subSubMenu.name.indexOf(words)>=0){

                                hasMatch = true;
                                hasSubMatch = true;
                                hasSubSubMatch = true;

                                tempMenu.children.push({
                                        title: "　　　" + subSubMenu.name,
                                        path: subSubMenu.url,
                                        // icon: subSubMenu.icon || "ios-list-box",
                                });
                            }
                            
                            if(this.menuList.length<=10){
                                    this.menuList.push({
                                            title: subSubMenu.name,
                                            path: subSubMenu.url,
                                            icon: subSubMenu.icon || "ios-list-box",
                                    })
                            }
                        }

                        if(!hasSubMatch && !hasSubSubMatch){
                            tempMenu.children.splice(tempMenu.children.length-1,1);
                        }
                   }

                    if(!hasMatch){
                        this.extendMenuList.splice(this.extendMenuList.length-1,1);
                    }

               }
            },
            changeDarkCss () {
                if(!this.isDark){
                    document.getElementsByTagName('body')[0].classList.add('ivu-theme-dark');
                    var key = "headerTheme";
                    var value = "dark";
                    this.updateLayoutSetting({
                        key,
                        value
                    });
                }else{
                    document.getElementsByTagName('body')[0].classList.remove('ivu-theme-dark');
                    var key = "headerTheme";
                    var value = "primary";
                    this.updateLayoutSetting({
                        key,
                        value
                    });
                }
                this.isDark = !this.isDark;
            },
            handleToggleDrawer (state) {
                if (typeof state === 'boolean') {
                    this.showDrawer = state;
                } else {
                    this.showDrawer = !this.showDrawer;
                }
            },
            handleScroll () {
                if (!this.headerHide) return;

                const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;

                if (!this.ticking) {
                    this.ticking = true;
                    requestAnimation(() => {
                        if (this.oldScrollTop > scrollTop) {
                            this.headerVisible = true;
                        } else if (scrollTop > 300 && this.headerVisible) {
                            this.headerVisible = false;
                        } else if (scrollTop < 300 && !this.headerVisible) {
                            this.headerVisible = true;
                        }
                        this.oldScrollTop = scrollTop;
                        this.ticking = false;
                    });
                }
            },
            handleHeaderWidthChange () {
                const $breadcrumb = this.$refs.breadcrumb;
                if ($breadcrumb) {
                    $breadcrumb.handleGetWidth();
                    $breadcrumb.handleCheckWidth();
                }
                const $menuHead = this.$refs.menuHead;
                if ($menuHead) {
                    $menuHead.handleGetMenuHeight();
                }
            },
            handleReload () {
                 // 针对缓存的页面也生效
                const isCurrentPageCache = this.keepAlive.indexOf(this.$route.name) > -1;
                const pageName = this.$route.name;
                if (isCurrentPageCache) {
                    this.keepAliveRemove(pageName);
                }
                this.loadRouter = false;
                this.$nextTick(() => {
                    this.loadRouter = true;
                    if (isCurrentPageCache) {
                        this.keepAlivePush(pageName);
                    }
                });
            },
            haveChange (total) {
                this.newNumber = total
            },
            getLatestNum (isJob) {
                this.abHttpUtil
                    .get('/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5')
                    .then(res => {
                  	  if(res.isOk){
                            var oldNumber = this.number;
                            this.number = Number(res.data.totalCount);
                            // this.number = this.number + 1;
                            this.newNumber = this.number;
                            if( this.openMsgBoxOnNewMsg && isJob && oldNumber<this.newNumber){
                                // 自动弹出消息盒子
                                if(document.querySelectorAll(".ivu-notifications-transfer")[0].style.display=="none"){
                                    document.querySelectorAll(".ivu-notifications-rel")[0].click();
                                }
                            }
                  	  }
                    });
            },
            handMenuTitle (menuList) {
               if(!menuList || menuList.length<1) return;

               for(var i=0,menu;menu=menuList[i++];){
            	   menu.title = menu.name;
            	   if(menu.children){
            		   this.handMenuTitle(menu.children);
            	   }
               }
            }
        },
        mounted () {
            document.addEventListener('scroll', this.handleScroll, { passive: true });
        },
        beforeDestroy () {
            document.removeEventListener('scroll', this.handleScroll);
        },
        created () {

            if (this.isTablet && this.showSiderCollapse) this.updateMenuCollapse(true);

            // 主框架打开的时候 加载菜单
            var thisVue = this;
            var denfer = thisVue.abHttpUtil.postForm("/org/userResource/userMsg", { system: "OA"});
            denfer.then(
              result => {
                // 无登录权限则跳转登陆
                if (!result.isOk) {
	              thisVue.$router.push({  name: "login" , query:{redirect:thisVue.$route.fullPath} });
                  if(result.code != '401'){
                  thisVue.$Message.error(result.msg);
                  }
                  this.abTools.loginToast = false;
                  return;
                }

                var userMsg = result.data;
                // TODO 将权限放到缓存中
                if (window.localStorage) {
                  window.localStorage.setItem(
                    "buttonPermision",
                    JSON.stringify(userMsg.buttonPermision)
                  );
                }

                const userDb =  this.$store.dispatch('admin/db/database', { user: true });
                userDb.then((db)=>{
                	db.set('userMenuList', userMsg.userMenuList).write();
                	db.set('buttonPermision', userMsg.buttonPermision).write();
                })


                this.$store.dispatch("admin/user/set", {
                    id: userMsg.user.id,
                    name: userMsg.user.fullname,
                    buttonPermision: userMsg.buttonPermision,
                    currentOrg: userMsg.currentOrg,
                    orgList: userMsg.orgList,
                    menuList: userMsg.userMenuList,
                    avatar: userMsg.user.photo?(thisVue.imgBaseUrl+userMsg.user.photo):"https://dev-file.iviewui.com/userinfoPDvn9gKWYihR24SpgC319vXY8qniCqj4/avatar"
                });

                this.userInfoLoaded = true;
                //获取页面配置权限
                this.getPagPermission();
                // 根据当前路由设置菜单
                const headerName = getHeaderName(this.$route.path, userMsg.userMenuList);
	            if (headerName) {
			        const menuSider = getMenuSider(userMsg.userMenuList,headerName);

		        	this.$store.commit("admin/menu/setSider", menuSider);
	                this.$store.commit('admin/menu/setHeaderName', headerName);
	                this.$store.commit('admin/menu/setActivePath', this.$route.fullPath);

	                const openNames = getSiderOpenNames(this.$route.fullPath, menuSider);
	                if(openNames.length>0){
		                this.$store.commit('admin/menu/setOpenNames', openNames);
	                }
               }
               
               // 加到扩展菜单中
               this.userMenuList = userMsg.userMenuList;

               this.initMutiFunctionMenu();


               let homename = "";
               let homeType = "";
                let platform_gm = this.abTools.hasAuthBtn('platform_gm',this);
                if(platform_gm){
                    this.homepageList.push({name:$t('sclm.homepage.generalManagerPortal'),value:1});
                    if(!homename){
                        homename = $t('sclm.homepage.generalManagerPortal');
                        homeType = 1;
                    }
                }
                let platform_finance = this.abTools.hasAuthBtn('platform_finance',this);
                if(platform_finance){
                    this.homepageList.push({name:$t('sclm.homepage.financialPortal'),value:2});
                    if(!homename){
                        homename = $t('sclm.homepage.financialPortal');
                        homeType = 2;
                    }
                }
                let platform_law = this.abTools.hasAuthBtn('platform_law',this);
                if(platform_law){
                    this.homepageList.push({name:$t('sclm.homepage.legalPortal'),value:3});
                    if(!homename){
                        homename = $t('sclm.homepage.legalPortal');
                        homeType = 3;
                    }
                }
                let platform_procure = this.abTools.hasAuthBtn('platform_procure',this);
                if(platform_procure){
                    this.homepageList.push({name:$t('sclm.homepage.procurementPortal'),value:4});
                    if(!homename){
                        homename = $t('sclm.homepage.procurementPortal');
                        homeType = 4;
                    }
                }
                let platform_sale = this.abTools.hasAuthBtn('platform_sale',this);
                if(platform_sale){
                    this.homepageList.push({name:$t('sclm.homepage.salePortal'),value:5});
                    if(!homename){
                        homename = $t('sclm.homepage.salePortal');
                        homeType = 5;
                    }
                }
                //菲婷丝法务门户
                let feitingSilk = this.abTools.hasAuthBtn('feitingSilk',this);
                if(feitingSilk){
                    this.homepageList.push({name:$t('sclm.homepage.legalPortal'),value:6});
                    if(!homename){
                        homename = $t('sclm.homepage.legalPortal');
                        homeType = 6;
                    }
                }

                if(homename){
                    this.homename = homename;
                    this.$store.commit('admin/menu/setHomeType', homeType);
                }

              },
              function(code) {
                thisVue.$Message.error("请求失败" + code);
              }
            );

            //通知 2 获取通知总条数
            // this.abHttpUtil
            //   .get("/oa/oAInstationMsg/getInstationMsg?type=2")
            //   .then(res => {
            //     this.number = Number(res.data.totalCount);
            //   });
              this.getLatestNum();
              setInterval(()=>{
                  this.getLatestNum(true);
              },5*60*1000);
            //   },1000);

              this.$root.$on("getLatestNum",this.getLatestNum);
        }
    }
</script>
